document.addEventListener("DOMContentLoaded", () => {
    const appEl = document.getElementById("giftletter-admin-app");
    if (!appEl) return;

    const { auth, db, storage, getQueryParam, generateId, generateToken, replaceSlackEmojiShortcodes } = window.GiftLetterFirebase;
    const giftId = getQueryParam("gid");
    const titleIconUrl = appEl.dataset.titleIcon || "";
    const POSTMARK_IMAGE_URL = appEl.dataset.postmarkImage || "";

    const state = {
        user: null,
        giftId: giftId || null,
        docRef: null,
        data: {
        title: "",
        subtitle: "",
        coverImageUrl: "",
        entries: [],
        published: false,
        viewToken: generateToken()
        }
    };

    function escapeHtml(str = "") {
        return String(str)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
    }

    async function compressImageFile(file, options = {}) {
        const {
            maxWidth = 1600,
            maxHeight = 1600,
            quality = 0.82,
            outputType = "image/jpeg"
        } = options;

        const imageBitmap = await createImageBitmap(file);

        let { width, height } = imageBitmap;
        const scale = Math.min(maxWidth / width, maxHeight / height, 1);

        const targetWidth = Math.round(width * scale);
        const targetHeight = Math.round(height * scale);

        const canvas = document.createElement("canvas");
        canvas.width = targetWidth;
        canvas.height = targetHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(imageBitmap, 0, 0, targetWidth, targetHeight);

        const blob = await new Promise((resolve, reject) => {
            canvas.toBlob((result) => {
            if (result) resolve(result);
            else reject(new Error("Image compression failed."));
            }, outputType, quality);
        });

        return blob;
        }

    function renderLogin() {
    appEl.innerHTML = `
        <div class="giftletter-admin-wrap">
        <div class="giftletter-admin-hero">
            <div class="giftletter-admin-heading">
            <p class="giftletter-admin-titleline">
                <span>GIFT LETTERS</span>
                ${titleIconUrl ? `<img src="${titleIconUrl}" alt="" class="giftletter-admin-titleicon">` : ""}
            </p>
            <h1 class="giftletter-admin-title">Admin Log in</h1>
            <p class="giftletter-admin-subtitle">Sign in to create and manage your Gift Letters.</p>
            </div>
        </div>

        <div class="giftletter-admin-paper">
            <div class="giftletter-form-row">
            <label>Email</label>
            <input id="login-email" type="email" class="giftletter-input" />
            </div>
            <div class="giftletter-form-row">
            <label>Password</label>
            <input id="login-password" type="password" class="giftletter-input" />
            </div>
            <button id="login-btn" class="giftletter-btn">Log in</button>
            <p id="login-error" class="giftletter-error"></p>
        </div>

        <footer class="giftletter-admin-footer">
            <p class="giftletter-admin-footer-text">Made with GIFT LETTER by JIYUCHO<br>Inspired by hope always.</p>
        </footer>
        </div>
    `;

    document.getElementById("login-btn").addEventListener("click", async () => {
        const email = document.getElementById("login-email").value.trim();
        const password = document.getElementById("login-password").value;

        try {
        await auth.signInWithEmailAndPassword(email, password);
        } catch (error) {
        document.getElementById("login-error").textContent = error.message || "Login failed.";
        }
    });
    }

    function renderApp() {
    const entriesHtml = state.data.entries
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((entry, index) => `
        <div class="giftletter-entry-card" data-entry-id="${entry.id}">
            <div class="giftletter-entry-head">
            <strong>Entry ${index + 1}</strong>
            <div class="giftletter-entry-actions">
                <button class="giftletter-btn small js-move-up" data-id="${entry.id}">Up</button>
                <button class="giftletter-btn small js-move-down" data-id="${entry.id}">Down</button>
                <button class="giftletter-btn small danger js-delete-entry" data-id="${entry.id}">Delete</button>
            </div>
            </div>
            <div class="giftletter-form-row">
            <label>Name</label>
            <input class="giftletter-input js-entry-name" data-id="${entry.id}" value="${escapeHtml(entry.name || "")}">
            </div>
            <div class="giftletter-form-row">
            <label>Message</label>
            <textarea class="giftletter-textarea js-entry-message" data-id="${entry.id}">${escapeHtml(entry.message || "")}</textarea>
            </div>
        </div>
        `)
        .join("");

    const publicUrl = state.data.published && state.giftId
        ? `${window.location.origin}/pages/giftletter-view?gid=${state.giftId}&token=${state.data.viewToken}`
        : "";

    appEl.innerHTML = `
        <div class="giftletter-admin-wrap">
        <div class="giftletter-admin-hero">
            <div class="giftletter-admin-heading">
            <p class="giftletter-admin-titleline">
                <span>GIFT LETTERS</span>
                ${titleIconUrl ? `<img src="${titleIconUrl}" alt="" class="giftletter-admin-titleicon">` : ""}
            </p>
            <h1 class="giftletter-admin-title">${escapeHtml(state.data.title || "New Gift Letter")}</h1>
            <p class="giftletter-admin-subtitle">Create and arrange messages in the same atmosphere as the final Gift Letter view.</p>

            <div class="giftletter-admin-actions-top">
                <button id="back-to-list-btn" class="giftletter-btn secondary">Back to list</button>
                <button id="logout-btn" class="giftletter-btn secondary">Log out</button>
            </div>
            </div>

            <div class="giftletter-admin-paper">
            <div class="giftletter-form-row">
                <label>Title</label>
                <input id="gift-title" class="giftletter-input" value="${escapeHtml(state.data.title)}">
            </div>

            <div class="giftletter-form-row">
                <label>Subtitle</label>
                <input id="gift-subtitle" class="giftletter-input" value="${escapeHtml(state.data.subtitle)}">
            </div>

            <div class="giftletter-form-row">
                <label>Cover image</label>
                <input id="gift-cover-file" type="file" accept="image/*" class="giftletter-input">
            </div>

            ${state.data.coverImageUrl ? `
                <div class="giftletter-cover-preview">
                <div class="giftletter-cover-preview-inner">
                    <img src="${state.data.coverImageUrl}" alt="">
                </div>
                ${POSTMARK_IMAGE_URL ? `<img class="giftletter-cover-preview-postmark" src="${POSTMARK_IMAGE_URL}" alt="">` : ""}
                </div>
            ` : ""}
            </div>
        </div>

        <div class="giftletter-admin-paper">
            <div class="giftletter-form-row">
            <label>Entries</label>
            <div id="entries-wrap" class="giftletter-entries-wrap">
                ${entriesHtml || '<p class="giftletter-muted">No entries yet.</p>'}
            </div>
            </div>

            <div class="giftletter-inline-actions">
            <button id="add-entry-btn" class="giftletter-btn secondary">Add entry</button>
            <button id="save-btn" class="giftletter-btn">Save</button>
            <button id="publish-btn" class="giftletter-btn">${state.data.published ? "Update public URL" : "Publish"}</button>
            </div>

            ${publicUrl ? `
            <div class="giftletter-public-box">
                <label>Public URL</label>
                <div class="giftletter-public-row">
                <input id="public-url" class="giftletter-input" readonly value="${escapeHtml(publicUrl)}">
                <button id="copy-url-btn" class="giftletter-btn secondary">Copy</button>
                </div>
            </div>
            ` : ""}

            <p id="save-status" class="giftletter-status"></p>
        </div>

        <div class="giftletter-admin-bottom-actions">
            <button class="giftletter-btn secondary js-back-to-list-bottom">Back to list</button>
        </div>

        <footer class="giftletter-admin-footer">
            <p class="giftletter-admin-footer-text">Made with GIFT LETTER by JIYUCHO<br>Inspired by hope always.</p>
        </footer>
        </div>
    `;

    bindAppEvents();
    }

    function bindAppEvents() {
        document.getElementById("logout-btn").addEventListener("click", async () => {
        await auth.signOut();
        });

        document.getElementById("gift-title").addEventListener("input", (e) => {
        state.data.title = e.target.value;
        });

        document.getElementById("gift-subtitle").addEventListener("input", (e) => {
        state.data.subtitle = e.target.value;
        });

        const backBtn = document.getElementById("back-to-list-btn");
        if (backBtn) {
        backBtn.addEventListener("click", async () => {
            state.giftId = null;
            state.docRef = null;
            state.data = {
            title: "",
            subtitle: "",
            coverImageUrl: "",
            entries: [],
            published: false,
            viewToken: generateToken()
            };
            const nextUrl = `${window.location.origin}/pages/giftletter-admin`;
            window.history.replaceState({}, "", nextUrl);
            await renderList();
        });
        }

        const backBottomBtn = document.querySelector(".js-back-to-list-bottom");
        if (backBottomBtn) {
        backBottomBtn.addEventListener("click", async () => {
            state.giftId = null;
            state.docRef = null;
            state.data = {
            title: "",
            subtitle: "",
            coverImageUrl: "",
            entries: [],
            published: false,
            viewToken: generateToken()
            };
            const nextUrl = `${window.location.origin}/pages/giftletter-admin`;
            window.history.replaceState({}, "", nextUrl);
            await renderList();
        });
        }

        document.getElementById("gift-cover-file").addEventListener("change", async (e) => {
            const file = e.target.files[0];
            if (!file) return;

            if (file.size > 15 * 1024 * 1024) {
                setStatus("画像サイズが大きすぎます。15MB以下にしてください。");
                return;
            }

            try {
                setStatus("Compressing image...");

                const compressedBlob = await compressImageFile(file, {
                maxWidth: 1600,
                maxHeight: 1600,
                quality: 0.82,
                outputType: "image/jpeg"
                });

                setStatus("Uploading image...");

                const uploadGiftId = state.giftId || "draft";
                const path = `giftletters/${uploadGiftId}/${Date.now()}_${file.name.replace(/\.[^.]+$/, "")}.jpg`;
                const ref = storage.ref().child(path);

                await ref.put(compressedBlob, {
                contentType: "image/jpeg"
                });

                state.data.coverImageUrl = await ref.getDownloadURL();
                renderApp();
                setStatus("Image uploaded.");
            } catch (error) {
                setStatus(error.message || "Image upload failed.");
            }
        });

        document.getElementById("add-entry-btn").addEventListener("click", () => {
        state.data.entries.push({
            id: generateId("entry"),
            name: "",
            message: "",
            sortOrder: state.data.entries.length + 1
        });
        renderApp();
        });

        document.querySelectorAll(".js-entry-name").forEach((input) => {
        input.addEventListener("input", (e) => {
            const id = e.target.dataset.id;
            const target = state.data.entries.find((item) => item.id === id);
            if (target) target.name = e.target.value;
        });
        });

        document.querySelectorAll(".js-entry-message").forEach((textarea) => {
        textarea.addEventListener("input", (e) => {
            const id = e.target.dataset.id;
            const target = state.data.entries.find((item) => item.id === id);
            if (target) target.message = e.target.value;
        });
        });

        document.querySelectorAll(".js-delete-entry").forEach((btn) => {
        btn.addEventListener("click", (e) => {
            const id = e.target.dataset.id;
            state.data.entries = state.data.entries.filter((item) => item.id !== id);
            normalizeSortOrder();
            renderApp();
        });
        });

        document.querySelectorAll(".js-move-up").forEach((btn) => {
        btn.addEventListener("click", (e) => {
            moveEntry(e.target.dataset.id, -1);
        });
        });

        document.querySelectorAll(".js-move-down").forEach((btn) => {
        btn.addEventListener("click", (e) => {
            moveEntry(e.target.dataset.id, 1);
        });
        });

        document.getElementById("save-btn").addEventListener("click", async () => {
        await saveGift(false);
        });

        document.getElementById("publish-btn").addEventListener("click", async () => {
        state.data.published = true;
        if (!state.data.viewToken) state.data.viewToken = generateToken();
        await saveGift(true);
        });

        const copyBtn = document.getElementById("copy-url-btn");
        if (copyBtn) {
        copyBtn.addEventListener("click", async () => {
            const url = document.getElementById("public-url").value;
            await navigator.clipboard.writeText(url);
            setStatus("Copied public URL.");
        });
        }
    }

    function moveEntry(id, direction) {
        const sorted = [...state.data.entries].sort((a, b) => a.sortOrder - b.sortOrder);
        const index = sorted.findIndex((item) => item.id === id);
        if (index < 0) return;

        const newIndex = index + direction;
        if (newIndex < 0 || newIndex >= sorted.length) return;

        [sorted[index], sorted[newIndex]] = [sorted[newIndex], sorted[index]];
        state.data.entries = sorted.map((item, i) => ({
        ...item,
        sortOrder: i + 1
        }));
        renderApp();
    }

    function normalizeSortOrder() {
        state.data.entries = state.data.entries
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((item, i) => ({
            ...item,
            sortOrder: i + 1
        }));
    }

    async function saveGift(isPublishAction) {
        try {
        setStatus("Saving...");
        normalizeSortOrder();

        if (!state.giftId) {
            state.docRef = db.collection("giftLetters").doc();
            state.giftId = state.docRef.id;
        } else if (!state.docRef) {
            state.docRef = db.collection("giftLetters").doc(state.giftId);
        }

        const now = firebase.firestore.FieldValue.serverTimestamp();
        const payload = {
            title: state.data.title || "",
            subtitle: state.data.subtitle || "",
            coverImageUrl: state.data.coverImageUrl || "",
            entries: (state.data.entries || []).map((entry) => ({
            ...entry,
            name: replaceSlackEmojiShortcodes(entry.name || ""),
            message: replaceSlackEmojiShortcodes(entry.message || "")
            })),
            published: !!state.data.published,
            viewToken: state.data.viewToken || "",
            updatedAt: now,
            createdBy: state.user.email
        };

        const snap = await state.docRef.get();
        if (!snap.exists) {
            payload.createdAt = now;
        }

        await state.docRef.set(payload, { merge: true });

        const nextUrl = `${window.location.origin}/pages/giftletter-admin?gid=${state.giftId}`;
        window.history.replaceState({}, "", nextUrl);

        renderApp();
        setStatus(isPublishAction ? "Published." : "Saved.");
        } catch (error) {
        setStatus(error.message || "Save failed.");
        }
    }

    async function loadGift(gid) {
    const docRef = db.collection("giftLetters").doc(gid);
    const snap = await docRef.get();
    if (!snap.exists) {
        throw new Error("Gift Letter not found.");
    }

    state.docRef = docRef;
    state.giftId = gid;
    const data = snap.data();

    state.data = {
        title: data.title || "",
        subtitle: data.subtitle || "",
        coverImageUrl: data.coverImageUrl || "",
        entries: Array.isArray(data.entries) ? data.entries : [],
        published: !!data.published,
        viewToken: data.viewToken || generateToken()
    };
    }

    async function loadGiftList() {
        const snap = await db
            .collection("giftLetters")
            .where("createdBy", "==", state.user.email)
            .orderBy("updatedAt", "desc")
            .get();

        return snap.docs.map((doc) => {
            const data = doc.data();
            return {
            id: doc.id,
            title: data.title || "Untitled",
            subtitle: data.subtitle || "",
            published: !!data.published,
            updatedAt: data.updatedAt,
            entryCount: Array.isArray(data.entries) ? data.entries.length : 0,
            viewToken: data.viewToken || ""
            };
        });
    }

    function formatDate(value) {
        if (!value) return "";
        try {
            const date = value.toDate ? value.toDate() : new Date(value);
            return date.toLocaleString("ja-JP");
        } catch {
            return "";
        }
    }

    async function renderList() {
    const gifts = await loadGiftList();

    const rows = gifts.map((gift) => {
        const publicUrl = gift.published
        ? `${window.location.origin}/pages/giftletter-view?gid=${gift.id}&token=${gift.viewToken}`
        : "";

        return `
        <div class="giftletter-list-item">
            <div class="giftletter-list-main">
            <p class="giftletter-list-title">${escapeHtml(gift.title)}</p>
            ${gift.subtitle ? `<p class="giftletter-list-subtitle">${escapeHtml(gift.subtitle)}</p>` : ""}
            <p class="giftletter-list-meta">
                ${gift.entryCount} entries ・ ${gift.published ? "Published" : "Draft"} ・ ${formatDate(gift.updatedAt)}
            </p>
            </div>
            <div class="giftletter-list-actions">
            <button class="giftletter-btn secondary js-open-gift" data-id="${gift.id}">Edit</button>
            <button class="giftletter-btn secondary js-copy-gift-url" data-url="${escapeHtml(publicUrl)}" ${publicUrl ? "" : "disabled"}>Copy URL</button>
            <button class="giftletter-btn danger js-delete-gift" data-id="${gift.id}">Delete</button>
            </div>
        </div>
        `;
    }).join("");

    appEl.innerHTML = `
        <div class="giftletter-admin-wrap">
        <div class="giftletter-admin-hero">
            <div class="giftletter-admin-heading">
            <p class="giftletter-admin-titleline">
                <span>GIFT LETTERS</span>
                ${titleIconUrl ? `<img src="${titleIconUrl}" alt="" class="giftletter-admin-titleicon">` : ""}
            </p>
            <h1 class="giftletter-admin-title">Your Gift Letters</h1>
            <p class="giftletter-admin-subtitle">Create, edit, and share messages for someone special.</p>

            <div class="giftletter-admin-actions-top">
                <button id="new-gift-btn" class="giftletter-btn">New Gift Letter</button>
                <button id="logout-btn" class="giftletter-btn secondary">Log out</button>
            </div>
            </div>
        </div>

        <div class="giftletter-admin-paper">
            <div class="giftletter-list-wrap">
            ${rows || '<p class="giftletter-muted">まだ寄せ書きはありません。</p>'}
            </div>
        </div>

        <footer class="giftletter-admin-footer">
            <p class="giftletter-admin-footer-text">Made with GIFT LETTER by JIYUCHO<br>Inspired by hope always.</p>
        </footer>
        </div>
    `;

    document.getElementById("logout-btn").addEventListener("click", async () => {
        await auth.signOut();
    });

    document.getElementById("new-gift-btn").addEventListener("click", () => {
        state.giftId = null;
        state.docRef = null;
        state.data = {
        title: "",
        subtitle: "",
        coverImageUrl: "",
        entries: [],
        published: false,
        viewToken: generateToken()
        };
        renderApp();
    });

    document.querySelectorAll(".js-open-gift").forEach((btn) => {
        btn.addEventListener("click", async (e) => {
        const id = e.currentTarget.dataset.id;
        await loadGift(id);
        const nextUrl = `${window.location.origin}/pages/giftletter-admin?gid=${id}`;
        window.history.replaceState({}, "", nextUrl);
        renderApp();
        });
    });

    document.querySelectorAll(".js-copy-gift-url").forEach((btn) => {
        btn.addEventListener("click", async (e) => {
        const url = e.currentTarget.dataset.url;
        if (!url) return;
        await navigator.clipboard.writeText(url);
        });
    });

    document.querySelectorAll(".js-delete-gift").forEach((btn) => {
        btn.addEventListener("click", async (e) => {
        const id = e.currentTarget.dataset.id;
        const ok = window.confirm("この寄せ書きを削除しますか？");
        if (!ok) return;

        await db.collection("giftLetters").doc(id).delete();
        await renderList();
        });
    });
    }

    function setStatus(text) {
        const el = document.getElementById("save-status");
        if (el) el.textContent = text;
    }

    auth.onAuthStateChanged(async (user) => {
        state.user = user || null;

        if (!user) {
            renderLogin();
            return;
        }

        try {
            if (state.giftId) {
            await loadGift(state.giftId);
            renderApp();
            } else {
            await renderList();
            }
        } catch (error) {
            appEl.innerHTML = `<div class="giftletter-card"><p class="giftletter-error">${escapeHtml(error.message || "Failed to load data.")}</p></div>`;
        }
    });
});